__turbopack_context__.v({
  "product-gallery": "ProductGallery-module-scss-module__3WocRG__product-gallery",
  "product-gallery--empty": "ProductGallery-module-scss-module__3WocRG__product-gallery--empty",
  "product-gallery__desktop": "ProductGallery-module-scss-module__3WocRG__product-gallery__desktop",
  "product-gallery__expand": "ProductGallery-module-scss-module__3WocRG__product-gallery__expand",
  "product-gallery__frame": "ProductGallery-module-scss-module__3WocRG__product-gallery__frame",
  "product-gallery__grid": "ProductGallery-module-scss-module__3WocRG__product-gallery__grid",
  "product-gallery__hero": "ProductGallery-module-scss-module__3WocRG__product-gallery__hero",
  "product-gallery__hero-img": "ProductGallery-module-scss-module__3WocRG__product-gallery__hero-img",
  "product-gallery__mobile": "ProductGallery-module-scss-module__3WocRG__product-gallery__mobile",
  "product-gallery__thumb": "ProductGallery-module-scss-module__3WocRG__product-gallery__thumb",
  "product-gallery__thumb--active": "ProductGallery-module-scss-module__3WocRG__product-gallery__thumb--active",
  "product-gallery__thumb-item": "ProductGallery-module-scss-module__3WocRG__product-gallery__thumb-item",
  "product-gallery__thumbs": "ProductGallery-module-scss-module__3WocRG__product-gallery__thumbs",
  "product-gallery__tile": "ProductGallery-module-scss-module__3WocRG__product-gallery__tile",
  "product-gallery__tile-img": "ProductGallery-module-scss-module__3WocRG__product-gallery__tile-img",
});
